namespace $.$$ {
	
	$mol_style_define( $giper_balls_requisites, {
		
		Info: {
			padding: $mol_gap.text,
		},
		
		OGRNIP: {
			margin: {
				top: $mol_gap.text,
			},
		},
		
		INN: {
			margin: {
				top: $mol_gap.text,
			},
		},
		
	} )
	
}
